// todo: probably a duplicate of flattenItem or similar nightmarish util function we have

import type { Activity } from 'types/store/activity';

export const formatActivities = (activities: any) => ({
  metadata: activities.metadata,
  activities: activities.data.map(({ date, ...rest }: any) => ({
    ...rest,
    date: date as unknown as Date,
  })) as Activity[],
});
